import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11dd8c92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ai-dialog" }
const _hoisted_2 = { class: "history-view" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "历史对话")
], -1))
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = { class: "history-box" }
const _hoisted_6 = {
  ref: "scrollContainer",
  "infinite-scroll-distance": "5",
  class: "infinite-list",
  style: {"overflow":"auto"}
}
const _hoisted_7 = {
  key: 0,
  class: "infinite-list-line"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "infinite-list-item-content" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { style: {"display":"flex","flex-direction":"column","align-items":"center"} }
const _hoisted_12 = { class: "chat-view" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "AI 对话")
], -1))
const _hoisted_14 = {
  class: "chat-box",
  ref: "chatBox"
}
const _hoisted_15 = {
  key: 0,
  class: "avatar-user"
}
const _hoisted_16 = {
  key: 1,
  class: "user-message message-bubble"
}
const _hoisted_17 = {
  key: 2,
  class: "avatar"
}
const _hoisted_18 = {
  key: 3,
  class: "ai-message message-bubble"
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-top" })
], -1))
const _hoisted_21 = { style: {"display":"flex"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ElPopover = _resolveComponent("ElPopover")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_backtop = _resolveComponent("el-backtop")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_card, null, {
        header: _withCtx(() => [
          _hoisted_3
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.inputOpen)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  style: {"width":"90%","border-radius":"20px"},
                  onClick: _ctx.initMessages
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新建对话")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (!_ctx.inputOpen)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  icon: "el-icon-search",
                  onClick: _ctx.showSearch,
                  circle: ""
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.inputOpen)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 2,
                  ref: "searchInput",
                  onBlur: _ctx.hideSearch,
                  modelValue: _ctx.keyword,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
                  autofocus: "",
                  placeholder: "搜索关键字",
                  "prefix-icon": "el-icon-search",
                  "input-style": {borderRadius:'20px'}
                }, null, 8, ["onBlur", "modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createElementBlock("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sessionGroups, (item, idx) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                  (item.divider)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_7, _toDisplayString(item.divider), 1))
                    : (_openBlock(), _createElementBlock("li", {
                        key: 1,
                        class: _normalizeClass(_ctx.sessionId == item.sessionId?'infinite-list-item active':'infinite-list-item'),
                        onClick: ($event: any) => (_ctx.loadData(item.sessionId))
                      }, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(item.content), 1),
                        _createVNode(_component_ElPopover, {
                          placement: "right",
                          offset: "-10",
                          width: 150,
                          trigger: "click",
                          modelValue: _ctx.sessionId,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sessionId) = $event))
                        }, {
                          reference: _withCtx(() => [
                            _createElementVNode("i", {
                              class: "el-icon-more-outline infinite-list-item-opt",
                              onClick: ($event: any) => (_ctx.loadData(item.sessionId))
                            }, null, 8, _hoisted_10)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_el_button, {
                                type: "danger",
                                plain: "",
                                size: "small",
                                style: {"width":"100px"},
                                onClick: ($event: any) => (_ctx.deleteSession(item.sessionId))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("删除")
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["modelValue"])
                      ], 10, _hoisted_8))
                ], 64))
              }), 128))
            ])), [
              [_directive_infinite_scroll, _ctx.fetchSessionGroups]
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_el_card, { class: "box-card" }, {
        header: _withCtx(() => [
          _hoisted_13
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "message"
              }, [
                (message.type === 'user')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                  : _createCommentVNode("", true),
                (message.type === 'user')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(message.content), 1))
                  : _createCommentVNode("", true),
                (message.type === 'ai')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                  : _createCommentVNode("", true),
                (message.type === 'ai')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", {
                        innerHTML: _ctx.compiledMarkdown(message.content)
                      }, null, 8, _hoisted_19)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 512),
          _createVNode(_component_el_backtop, {
            target: ".chat-box",
            right: 80,
            bottom: 150
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.inputMessage,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputMessage) = $event)),
              placeholder: "请输入您的消息",
              onKeyup: _withKeys(_ctx.sendMessage, ["enter"])
            }, null, 8, ["modelValue", "onKeyup"]),
            _createVNode(_component_el_button, {
              type: "primary",
              loading: _ctx.loading,
              onClick: _ctx.sendMessage
            }, {
              default: _withCtx(() => [
                _createTextVNode("发送")
              ]),
              _: 1
            }, 8, ["loading", "onClick"]),
            _createVNode(_component_el_button, {
              type: "danger",
              onClick: _ctx.stopMsg
            }, {
              default: _withCtx(() => [
                _createTextVNode("终止")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}